import { Injectable } from '@angular/core';
import { RestGeneric } from '../rest.generic';
import { Membership } from './interfaces/membership';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthFactoryService } from '../../auth/auth-factory.service';
import { RestGenericUtilService } from '../rest-generic-util.service';
import { MembershipRequest } from './interfaces/membership-request';
import { environment } from '../../../../../environments/environment';


@Injectable({
    providedIn: 'root'
})
export class MembershipService extends RestGeneric<any, Membership, any> {
    protected baseApiUrl = environment.EduSpireApi.baseUrl;
    constructor(
        protected http: HttpClient,
        protected authFactoryService: AuthFactoryService,
        protected restGenericUtilService: RestGenericUtilService
    ) {
        super(http, authFactoryService, '', restGenericUtilService);
    }

    patch(updateType: MembershipRequest, uuid: string): Observable<Membership> {
        return this.http.patch<Membership>(`${this.baseApiUrl}/district/school/membership/${uuid}`, updateType);
    }

    changeDefaultSchool(defaultSchoolMembership: string): Observable<HttpResponse<any>> {
        return this.http.patch<HttpResponse<any>>(`${this.baseApiUrl}/district/school/membership/${defaultSchoolMembership}/default-school`, {});
    }
}
